import React, { useEffect, useState } from "react";
import DatosUsuario from "./components/DatosUsuario";
import InfoCursos from "./components/InfoCursos";
import ModalCertificado from "./components/ModalCertificado";
import UniversalIconPerfil from "../../../../components/UniversalIconoPerfil/UniversalIconPerfil";

export default function MiPerfil({ homeContainerRef }) {
  const [vIsScrollTop, setVIsScrollTop] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      homeContainerRef.current && homeContainerRef.current.scrollTop > 0
        ? setVIsScrollTop(false)
        : setVIsScrollTop(true);
    };

    const scrollElement = homeContainerRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <div
        data-figma-id="810:15668"
        class="header-style"
        style={{
          
          backgroundColor: vIsScrollTop ? "transparent" : "#1d1d1d" }}
      >
        <p data-figma-id="810:15669" class="header-texto">
          Mi Perfil
        </p>
        <div data-figma-id="810:15670" class="header-iconos">
          <i class="fi fi-rs-bell bell-1-2"></i>
          <UniversalIconPerfil />
        </div>
      </div>
      <div data-figma-id="1623:15391" className="perfil-contenido-info">
        <p data-figma-id="1620:14272" className="perfil-info-titulo">
          ¡Bienvenido! 👋🏼
        </p>
        <div className="linea-miscursos-h"></div>
        <div data-figma-id="1620:14274" className="perfil-info">
          {/* Se pasa homeContainerRef a DatosUsuario */}
          <DatosUsuario homeContainerRef={homeContainerRef} />
          <InfoCursos />
        </div>
      </div>
    </>
  );
}
